import React from "react";
import CzrLink from "~/components/CustomMDX/CzrLink/CzrLink";
import cx from "@caesars-ui/core/dist/utils/cx";
import { Badge } from "@caesars-ui/core";

const Col = ({ children, is }) => {
  return (
    <div
      className={cx(
        {
          "text-center": is !== "name",
        },
        "border-b-1 border-solid border-fg-minimal py-4 body-lg text-fg-default"
      )}
    >
      {children}
    </div>
  );
};


const ComponentListRow = ({ data }) => {
  return (
    <>
      <Col is="name">
        {data.Documentation === "Ready" ? (
          <CzrLink to={`/components/${data.Slug}`} className="body-lg">{data.Name}</CzrLink>
        ) : (
          data.Name
        )}
      </Col>
      <Col>{!data.Figma_Library ? "--" : <Badge status={data.Figma_Library === "Ready" ? "positive" : data.Figma_Library === "Planned" ? "info" : undefined} type={data.Figma_Library === "Partially Ready" ? "subtle" : undefined} text={data.Figma_Library} size="sm" />}</Col>
      <Col>{!data.Documentation ? "--" : <Badge status={data.Documentation === "Ready" ? "positive" : data.Documentation === "Planned" ? "info" : undefined} type={data.Documentation === "Partially Ready" ? "subtle" : undefined} text={data.Documentation} size="sm" />}</Col>
      <Col>{!data.Web ? "--" : <Badge status={data.Web === "Ready" ? "positive" : data.Web === "Planned" ? "info" : undefined} type={data.Web === "Partially Ready" ? "subtle" : undefined} text={data.Web} size="sm" />}</Col>
      <Col>{!data.iOS ? "--" : <Badge status={data.iOS === "Ready" ? "positive" : data.iOS === "Planned" ? "info" : undefined} type={data.iOS === "Partially Ready" ? "subtle" : undefined} text={data.iOS} size="sm" />}</Col>
    </>
  );
};

export default ComponentListRow;
